import { Lock2Line } from '@datanomik/commons-ui/icons';
import { SvgIconTypeMap } from '@mui/material';

type BankIntegrationCredentialIconProps = SvgIconTypeMap['props'];
export const BankIntegrationCredentialIcon = (props: BankIntegrationCredentialIconProps) => (
  <Lock2Line {...props} />
);
